module.exports = __webpack_public_path__ + "6ab8de30f982ca42e169139cf5aeae8c.png";